import {get,post} from './httpApi';
import {getUserId} from "../utils/auth";
/*订单使用余额支付*/
export function payForAccount(data=null){
    return post('/orderPay/payForAccount',data)
}
/*订单使用易宝支付*/
export function payForYb(data=null){
    return post('/orderPay/payForYb',data)
}
/*拼接易宝请求地址*/
export function getYbUrl(data=null){
    return post('/orderPay/getYbUrl',data)
}
/*拼接请求地址Pc端*/
export function getYbUrlForPc(data=null){
    return post('/orderPay/getYbUrlForPc',data)
}
export function alipayForOrderQR(orderId) {
    return post('/orderPay/alipayForOrderQR',orderId)
}
export function wxPayForOrderNative(orderId) {
    return post('/orderPay/wxPayForOrderNative',orderId)
}
/**
 *
 * 验证支付密码
 * @return
 */
export function checkPayPsd(payPassword){
    return get('/orderPay/checkPayPsd',{
        payPassword,
        userId:getUserId()
    })
}